import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PaymentResponseComponent } from './paymentResponse.component';
import { TranslateModule } from '@ngx-translate/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DialogModule } from '@angular/cdk/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { PaymentPopupComponent } from './payment-popup/payment-popup.component';

@NgModule({
    declarations: [
        PaymentResponseComponent,
        PaymentPopupComponent
    ],
    exports: [
        PaymentPopupComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        DialogModule,
        MatDialogModule,
        MatButtonModule,
        TranslateModule
    ],
    providers: [provideHttpClient(withInterceptorsFromDi())]
})

export class PaymentResponseModule { }